var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F4F1",
    d: "M0 0h112v112H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5 54.5V26.88h3V54.5h27.62v3H57.5v27.62h-3V57.5H26.88v-3H54.5z",
    fill: "#231F20"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEyIiBoZWlnaHQ9IjExMiIgdmlld0JveD0iMCAwIDExMiAxMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIxMTIiIGhlaWdodD0iMTEyIiBmaWxsPSIjRjVGNEYxIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNTQuNSA1NC41TDU0LjUgMjYuODhINTcuNUw1Ny41IDU0LjVMODUuMTIgNTQuNVY1Ny41TDU3LjUgNTcuNUw1Ny41IDg1LjEySDU0LjVMNTQuNSA1Ny41TDI2Ljg4IDU3LjVWNTQuNUw1NC41IDU0LjVaIiBmaWxsPSIjMjMxRjIwIi8+Cjwvc3ZnPgoK";
export { SvgPlusCursor as ReactComponent };